<script setup>
import { getCurrentInstance, ref, onMounted, onDeactivated } from 'vue'
import { usePlaylistStore } from "@/stores/playlist.js";

const instance = getCurrentInstance();
const plStore = usePlaylistStore();

const props = defineProps({
    index: {
        type: Number,
        default: undefined,
    },
    cardId: {
        type: Number,
        default: undefined,
    },
    scormExport: Boolean,
})

const root = ref(null)
let isTracking = false
let isThisLastCard = false;

let observer;

const firstPathSegment = window.location.pathname.split('/')[1];

onMounted(() => {

    const currIndex = props.index
    const currSlide = document.querySelector("[data-slide-index='" + currIndex + "']")
    const slideParent = currSlide.parentElement
    isThisLastCard = ((plStore.cards.length -1) == props.index)

    observer = new IntersectionObserver(items => {
        items.forEach(item => {
            if (item.isIntersecting) {
                // start tracking
                isTracking = true
                plStore.setCurrentSlideIndex(props.index)
                //store.updateSlideType(props.slideType)
                storeTracking(true)
                storeCurrentSlide()
            } else {
                // stop tracking
                if (isTracking) {
                    isTracking = false
                    storeTracking(false)
                }
            }
        });
    }, {
        threshold: 0.9,
        root: slideParent,
    });

    observer.observe(currSlide)
});

onDeactivated(() => {
    observer.disconnect();
})

function storeTracking(start) {
    if (firstPathSegment === 'preview' || firstPathSegment === 'admin' || props.scormExport) return;

    const url = '/activity/store'
    const data = {
        playlist_id: plStore.playlistId,
        playlist_card_id: props.cardId,
        start: start,
        isLastCard: isThisLastCard
    }

    axios.post(url, data)  
        .then(function (response) {  
            // do nothing
        })  
        .catch(function (error) { 
            // do nothing
        });
}

function storeCurrentSlide() {
    if (firstPathSegment === 'preview' || firstPathSegment === 'admin') return;

    if (props.scormExport) {
        const scormApi = instance.appContext.config.globalProperties.$scorm.api;
        if (scormApi) {
            scormApi.setLessonLocation(props.cardId);
            scormApi.setIsLastChild(isThisLastCard);
        }
    } else {
        const currentUrl = new URL(window.location.href);
        const slug = currentUrl.pathname.split('/')[2];
        const pw = currentUrl.searchParams.get('p');
        
        const url = '/activity/set-current'
        const data = {
            playlist_id: plStore.playlistId,
            playlist_card_id: props.cardId,
            slug: slug,
            pw: pw
        }
        axios.post(url, data)  
            .then(function (response) {  
                // do nothing
            })  
            .catch(function (error) { 
                // do nothing
            }); 
    }
}

</script>

<template>
    <div />
</template>